// extracted by mini-css-extract-plugin
export default {"scrollContainer":"b5366cd1"};